import React from "react";
import { useTranslation } from "react-i18next";

import Label from "../../../ui/components/Label/Label";
import PageView from "../../../ui/views/PageView/PageView";

export default function SerieView({ serie, children }) {
	const { t } = useTranslation();

	return (
		<PageView
			header={serie.name}
			subheader={serie.publisher?.name}
			extra={
				<>
					<Label>{t("serie", "Serie")}</Label>
				</>
			}
		>
			{children}
		</PageView>
	);
}
